import { call, put } from 'redux-saga/effects';

import * as action from '../../actions';
import * as actNotif from '../../actions/notifications';

import * as api from '../../api/update-filtered-date';
import { assertErrorHasMessage } from '../../utils/assert';

export function* updateFilteredDate(query) {
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());

  try {
    const response = yield call(api.updateFilteredDate, query);
    return response.data;
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
    return false;
  } finally {
    yield put(action.hideProgressBar());
    yield put(action.sendingRequest(false));
  }
}

/**
 * @param {Moment} startDate
 * @param {Moment} endDate
 */
export function* updateFilteredDateFromMoment(startDate, endDate) {
  const query = {
    from: startDate.toString(),
    to: endDate.startOf('day').toString(),
  };
  return yield call(updateFilteredDate, query);
}
